import type { TypographyVariantsOptions } from '@mui/material/styles';

import { tokens } from './tokens';

/**
 * Type scale — dark, confident titles; quiet, readable body.
 * Negative tracking on display sizes keeps headlines crisp;
 * overline doubles as the "blueprint label" style (mono-feel, wide tracking).
 */
export const typography: TypographyVariantsOptions = {
  fontFamily: tokens.font.family,
  fontSize: tokens.font.sizeBase,
  h1: { fontSize: '2.5rem', fontWeight: 700, lineHeight: 1.15, letterSpacing: '-0.025em' },
  h2: { fontSize: '2rem', fontWeight: 700, lineHeight: 1.2, letterSpacing: '-0.02em' },
  h3: { fontSize: '1.625rem', fontWeight: 700, lineHeight: 1.25, letterSpacing: '-0.01em' },
  h4: { fontSize: '1.25rem', fontWeight: 600, lineHeight: 1.3, letterSpacing: '-0.005em' },
  h5: { fontSize: '1.125rem', fontWeight: 600, lineHeight: 1.4 },
  h6: { fontSize: '1rem', fontWeight: 600, lineHeight: 1.4 },
  subtitle1: { fontSize: '0.9375rem', fontWeight: 600, lineHeight: 1.5 },
  subtitle2: { fontSize: '0.8125rem', fontWeight: 600, lineHeight: 1.45 },
  body1: { fontSize: '0.9375rem', lineHeight: 1.55 },
  body2: { fontSize: '0.8125rem', lineHeight: 1.5 },
  button: { textTransform: 'none', fontWeight: 600, letterSpacing: '0.01em' },
  caption: { fontSize: '0.75rem', lineHeight: 1.45, letterSpacing: '0.01em' },
  overline: {
    fontFamily: tokens.font.familyMono,
    fontSize: '0.6875rem',
    // 500 — JetBrains Mono 600 at 11px uppercase is too heavy now that the real font loads.
    fontWeight: 500,
    letterSpacing: '0.14em',
    textTransform: 'uppercase' as const,
    lineHeight: 1.6,
  },
};
